// frontend/src/lib/recentlyAdded.ts
// "New since you last viewed this project" — a per-project localStorage
// timestamp + a pure helper that flags rows created after it. Used to
// highlight registry rows auto-promoted into a project since the user
// last looked. Per-browser (localStorage); does not sync across devices.

const KEY_PREFIX = "timlul:project-last-viewed:";

export function readProjectLastViewed(projectId: string): string | null {
  try {
    return localStorage.getItem(KEY_PREFIX + projectId);
  } catch {
    return null;
  }
}

export function writeProjectLastViewed(projectId: string, iso: string): void {
  try {
    localStorage.setItem(KEY_PREFIX + projectId, iso);
  } catch {
    /* storage unavailable — highlight silently degrades to off */
  }
}

/** Ids of rows whose created_at is strictly after `seenBefore`.
 *  `seenBefore === null` (never visited) → empty set, so a first visit
 *  doesn't flag the whole registry as "new". */
export function markNewSince<T extends { id: string; created_at: string }>(
  rows: T[],
  seenBefore: string | null,
): Set<string> {
  const out = new Set<string>();
  if (!seenBefore) return out;
  const cutoff = Date.parse(seenBefore);
  if (Number.isNaN(cutoff)) return out;
  for (const r of rows) {
    const t = Date.parse(r.created_at);
    if (!Number.isNaN(t) && t > cutoff) out.add(r.id);
  }
  return out;
}
